import {Moment} from 'moment';
import React from 'react';

import CalendarActions from './CalendarActions';

interface Props {
  date: Moment;
  children: (onMouseOver: () => void) => JSX.Element;
}

export default class MouseOverCapturer extends React.Component<Props> {
  onMouseOver(): void {
    CalendarActions.dayMouseOver(this.props.date);
  }

  override render(): JSX.Element {
    return this.props.children(() => {
      this.onMouseOver();
    });
  }
}
